import * as Yup from "yup";

export const getValidationSchema = (isInvited) => {
  return Yup.object().shape({
    nom: Yup.string().required("Le nom est requis"),
    prenom: Yup.string().required("Le prénom est requis"),
    pseudo: Yup.string().required("Le pseudo est requis"),
    dateNaissance: Yup.date().required("La date de naissance est requise"),
    adressePostale: Yup.string().required("L'adresse postale est requise"),
    email: Yup.string().email("Email invalide").required("L'email est requis"),
    telephone: Yup.string().required("Le téléphone est requis"),
    motivation: Yup.string().required("Cette information est requise"),
    vehicule: Yup.string().required("Cette information est requise"),
    city: Yup.string().required("La ville est requise"),
    zipCode: Yup.string().required("Le code postal est requis"),
    pmr: Yup.boolean(),
    idDiscord: Yup.string().required("L'ID Discord est requis"),
    domainePratique: Yup.array().min(
      1,
      "Sélectionnez au moins un domaine de pratique",
    ),
    statut: isInvited
      ? Yup.string()
      : Yup.string().required("Le statut est requis"),
    modePaiement: isInvited
      ? Yup.string()
      : Yup.string().required("Le mode de paiement est requis"),
    reglementInterieurLu: Yup.boolean().oneOf(
      [true],
      "Vous devez lire et approuver le règlement intérieur",
    ),
    dateSignature: Yup.date().required("La date de signature est requise"),
  });
};
